/**
 * Código de invitación del programa de referidos. La página /r/:code lo guarda
 * en este navegador; el alta (LoginCard) lo envía a la API para atribuir el
 * referido. Quien se registre desde la app de escritorio lo teclea allí a mano.
 */

const KEY = 'nukli_referral_code';

/** Normaliza lo que llega por la URL: mayúsculas y solo A-Z0-9 (igual que la API). */
export function normalizeReferralCode(raw) {
  const code = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return code.length >= 4 && code.length <= 16 ? code : '';
}

export function saveReferralCode(raw) {
  const code = normalizeReferralCode(raw);
  if (!code) return '';
  try {
    localStorage.setItem(KEY, code);
  } catch {
    /* modo privado o almacenamiento lleno: el código se pierde, no pasa nada */
  }
  return code;
}

export function getReferralCode() {
  try {
    return normalizeReferralCode(localStorage.getItem(KEY));
  } catch {
    return '';
  }
}

export function clearReferralCode() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nada que limpiar */
  }
}
